export default __webpack_public_path__ + "6d5d40f63bcf2704d8cada2c30eecdf0.svg";